import config from 'message-control/config'

const customerApi = `${config.apiHost}/oem-customer`

export default {
    getList: {
        url: `${customerApi}/api/conversation_tags`,
        type: 'GET',
    },
    create: {
        url: `${customerApi}/api/conversation_tags`,
        type: 'POST',
    },
    edit: {
        url: `${customerApi}/api/conversation_tags/{id}`,
        type: 'PUT',
    },
    remove: {
        url: `${customerApi}/api/conversation_tags/{id}`,
        type: 'DELETE',
    },
}
